<template lang="pug">
.b-user-empty-tile
  ._no-user(@click="$emit('select')")
    UserAvatar._avatar(:user="{}" :size="size")
    ._no-name.name(v-if="label") {{ label }}
</template>

<script>
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  name: 'UserEmptyTile',
  components: { UserAvatar },
  props: {
    label: String,
    editable: Boolean,
    size: Number,
  },
};
</script>

<style scoped lang="scss">
.user-empty-tile {
  display: flex;
  align-items: center;
  color: var(--color-dark-gray);
  justify-content: space-between;

  &__no-user {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
  }

  &__avatar {
    flex-shrink: 0;
  }

  &__no-name {
    text-align: left;
    max-width: 125px;
    line-height: 17px;
    font-size: 14px;
    color: var(--color-middle-gray);
    border-bottom: .5px dashed rgba(120, 140, 161, 0.5);

    &:hover {
      border-bottom-color: transparent;
    }
  }
}
</style>
